module.exports = __webpack_public_path__ + "static/async_meme-d7d5cb56aee43d5d381e3e9efb90c3b7.jpg";